import CloseIcon from '@mui/icons-material/Close';
import * as React from 'react';
import './ConfirmationDialog.css';
import { Dialog } from '@mui/material';
import { useState } from 'react';

function LogOutConfirmation(props) {
  const [Open, setOpen] = useState(true);
  return (
    <Dialog
      open={Open}
      style={{
        backgroundColor: 'transparent',
      }}
    >
      <div className="background">
        <div className="container">
          <div className="crossbutton">
            <h1 className="logoutheading"> Warning!</h1>
            <CloseIcon
              sx={{ cursor: 'pointer' }}
              onClick={() => {
                setOpen(false);
                props.closedialogs(false);
              }}
            />
          </div>
          <div className="body">
            Are you sure, you want to LOG OUT?
            <div className="footer">
              <button
                id="canclbtn"
                onClick={() => {
                  setOpen(false);
                  props.closedialogs(false);
                }}
              >
                Cancel
              </button>
              <button
                id="continuebtn"
                onClick={() => {
                  props.closedialogs(true);
                }}
              >
                Log Out
              </button>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
}

export default LogOutConfirmation;
